var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Day, MS_PER_DAY, ZonedDate, getDate, addDays } from '@progress/kendo-date-math';
import { BaseView } from '../../components/BaseView';
import { HorizontalResourceIterator } from '../common/HorizontalResourceIterator';
import { DayViewGroupRowContent } from './DayViewGroupRowContent';
import { VerticalResourceIterator } from '../common/VerticalResourceIterator';
import { DayViewAllDayRowContent } from './DayViewAllDayRowContent';
import { DayViewRowContent } from './DayViewRowContent';
import { DayViewMiddleRow } from './DayViewMiddleRow';
import { DayViewVerticalRow } from './DayViewVerticalRow';
import { DayViewHead } from './DayViewHead';
import { DayViewAllDaySlots } from './DayViewAllDaySlots';
import { mapItemsToSlots, mapSlotsToItems, isInTimeRange, toUTCDateTime, intersects, first, last } from '../../utils/main';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { MS_PER_MINUTE } from '../../constants/main';
import { toRanges, toItems, toSlots, toOccurrences } from '../../services/main';
import { SchedulerDrag } from '../../views/common/SchedulerDrag';
import { SchedulerEditSlot } from '../../slots/SchedulerEditSlot';
import { SchedulerEditItem } from '../../items/SchedulerEditItem';
import { CurrentTimeMarker } from '../../components/CurrentTimeMarker';
import { CurrentTimeMarkerArrow } from '../../components/CurrentTimeMarkerArrow';
import { SchedulerResize } from '../common/SchedulerResize';
var FIRST_INDEX = 0;
/** @hidden */
export var GRID_OFFSET = 1;
/** @hidden */
var MultiDayViewVue2 = {
  name: 'KendoMultiDayView',
  props: {
    name: {
      type: String,
      default: 'multi-day'
    },
    title: {
      type: String,
      default: 'Multi Day'
    },
    currentTimeMarker: {
      type: Boolean,
      default: true
    },
    dateRange: {
      type: [Function, Object],
      default: function _default() {
        return multiDayViewDateRange;
      }
    },
    numberOfDays: {
      type: Number,
      default: 1
    },
    startTime: {
      type: String,
      default: '00:00'
    },
    endTime: {
      type: String,
      default: '23:59'
    },
    workDayStart: {
      type: String,
      default: '08:00'
    },
    workDayEnd: {
      type: String,
      default: '17:00'
    },
    workWeekStart: {
      type: Number,
      default: Day.Monday
    },
    workWeekEnd: {
      type: Number,
      default: Day.Friday
    },
    step: {
      type: Number,
      default: 1
    },
    slotDivisions: {
      type: Number,
      default: 2
    },
    slotDuration: {
      type: Number,
      default: 60
    },
    showWorkHours: {
      type: Boolean,
      default: true
    },
    selectedDateFormat: {
      type: String,
      default: '{0:D} - {1:D}'
    },
    selectedShortDateFormat: {
      type: String,
      default: '{0:d} - {1:d}'
    },
    dragItem: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    resizeItem: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    format: {
      type: String,
      default: 't'
    },
    defaultShowWorkHours: {
      type: Boolean,
      default: true
    },
    dateHeaderCell: [String, Function, Object],
    timeHeaderCell: [String, Function, Object],
    slotRender: [String, Function, Object],
    viewSlot: [String, Function, Object],
    resizeHint: [String, Function, Object],
    item: [String, Function, Object],
    viewItem: [String, Function, Object],
    editable: {
      type: [Boolean, Object],
      default: false
    }
  },
  inject: {
    kendoIntlService: {
      default: null
    },
    ks: {
      default: null
    }
  },
  computed: {
    viewStart: function viewStart() {
      this.intl = provideIntlService(this);
      var workDayStart = this.intl.parseDate(this.$props.workDayStart);
      var startTime = this.intl.parseDate(this.$props.startTime);
      return (this.ks.showWorkHours !== undefined ? this.ks.showWorkHours : this.showWorkHours) ? workDayStart : startTime;
    },
    viewEnd: function viewEnd() {
      this.intl = provideIntlService(this);
      var workDayEnd = this.intl.parseDate(this.$props.workDayEnd);
      var endTime = this.intl.parseDate(this.$props.endTime);
      return (this.ks.showWorkHours !== undefined ? this.ks.showWorkHours : this.showWorkHours) ? workDayEnd : endTime;
    },
    dayRanges: function dayRanges() {
      return toRanges(this.ks.dateRange, {
        step: MS_PER_DAY * this.numberOfDays,
        timezone: this.ks.timezone
      }).map(function (r) {
        return __assign(__assign({}, r), {
          isAllDay: true
        });
      });
    },
    timeRanges: function timeRanges() {
      return toRanges(this.ks.dateRange, {
        step: MS_PER_DAY,
        timezone: this.ks.timezone
      }).map(function (r) {
        return __assign(__assign({}, r), {
          isAllDay: false
        });
      });
    },
    daySlots: function daySlots() {
      return toSlots(this.ks.dateRange, {
        step: MS_PER_DAY
      }, {
        groups: this.ks.groups,
        ranges: this.dayRanges
      });
    },
    timeSlots: function timeSlots() {
      var that = this;
      return toSlots(this.ks.dateRange, {
        step: this.slotDuration * MS_PER_MINUTE / this.slotDivisions
      }, {
        groups: this.ks.groups,
        ranges: this.timeRanges
      }).filter(function (slot) {
        return that.viewEnd.getTime() === that.viewStart.getTime() || isInTimeRange(slot.zonedStart, that.viewStart, that.viewEnd);
      });
    },
    occurrences: function occurrences() {
      return toOccurrences(this.ks.dataItems, {
        dateRange: this.ks.dateRange,
        fields: this.ks.fields,
        timezone: this.ks.timezone
      });
    },
    dayOccurrences: function dayOccurrences() {
      return this.occurrences.filter(function (o) {
        return o.isAllDay;
      });
    },
    timeOccurrences: function timeOccurrences() {
      return this.occurrences.filter(function (o) {
        return !o.isAllDay;
      });
    },
    dayItems: function dayItems() {
      var dayItems = toItems(this.dayOccurrences, {
        timezone: this.ks.timezone
      }, {
        groups: this.ks.groups,
        ranges: this.dayRanges
      });
      mapItemsToSlots(dayItems, this.daySlots, false);
      mapSlotsToItems(dayItems, this.daySlots, false);
      return dayItems;
    },
    timeItems: function timeItems() {
      var _this = this;
      var timeItems = toItems(this.timeOccurrences, {
        timezone: this.ks.timezone
      }, {
        groups: this.ks.groups,
        ranges: this.timeRanges
      }).filter(function (item) {
        return _this.viewStart.getTime() === _this.viewEnd.getTime() || isInTimeRange(item.zonedStart, _this.viewStart, _this.viewEnd) || isInTimeRange(item.zonedEnd, _this.viewStart, _this.viewEnd) || isInTimeRange(new Date(item.zonedEnd.getTime() - (item.zonedEnd.getTime() - item.zonedStart.getTime()) / 2), _this.viewStart, _this.viewEnd);
      });
      mapItemsToSlots(timeItems, this.timeSlots, false);
      mapSlotsToItems(timeItems, this.timeSlots, false);
      return timeItems;
    },
    compDragItem: function compDragItem() {
      return this.dragItem !== undefined ? this.dragItem : this.currentDragItem;
    },
    compResizeItem: function compResizeItem() {
      return this.resizeItem !== undefined ? this.resizeItem : this.currentResizeItem;
    }
  },
  data: function data() {
    return {
      hasMounted: false,
      currentDragItem: undefined,
      currentResizeItem: undefined
    };
  },
  mounted: function mounted() {
    this.hasMounted = true;
  },
  created: function created() {
    this.intl = provideIntlService(this);
  },
  beforeUpdate: function beforeUpdate() {
    this.intl = provideIntlService(this);
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this2 = this;
    var h = gh || createElement;
    this.intl = provideIntlService(this);
    var EditItem = this.$props.editItem || SchedulerEditItem;
    var EditSlot = this.$props.editSlot || SchedulerEditSlot;
    var showWorkHours = this.$props.showWorkHours;
    var numberOfDays = this.$props.numberOfDays;
    var slotDivisions = this.$props.slotDivisions;
    var slotDuration = this.$props.slotDuration;
    var workWeekStart = this.$props.workWeekStart;
    var workWeekEnd = this.$props.workWeekEnd;
    var workDayStart = this.intl.parseDate(this.$props.workDayStart);
    var workDayEnd = this.intl.parseDate(this.$props.workDayEnd);
    var dayItems = this.dayItems;
    var timeItems = this.timeItems;
    var daySlots = this.daySlots;
    var timeSlots = this.timeSlots;
    var dragItemClue = function dragItemClue(vertical) {
      return this.compDragItem && this.$props.editable.drag && (Array.isArray(this.compDragItem) ? this.compDragItem.map(function (di, idx) {
        return h(SchedulerDrag, {
          key: idx
          //   ignoreIsAllDay={ignoreIsAllDay}
          ,
          dataItem: di,
          attrs: this.v3 ? undefined : {
            dataItem: di,
            vertical: vertical,
            item: this.$props.dataItem
          },
          vertical: vertical,
          item: this.$props.dataItem
        });
      }, this) : h(SchedulerDrag
      //    ignoreIsAllDay={ignoreIsAllDay}
      , {
        dataItem: this.compDragItem,
        attrs: this.v3 ? undefined : {
          dataItem: this.compDragItem,
          vertical: vertical,
          item: this.$props.dataItem
        },
        vertical: vertical,
        item: this.$props.dataItem
      }));
    };
    var resizeItemClue = function resizeItemClue(vertical) {
      return this.compResizeItem && this.editable.resize && (Array.isArray(this.compResizeItem) ? this.compResizeItem.map(function (ri, idx) {
        return h(SchedulerResize, {
          key: idx,
          format: this.$props.format
          //   ignoreIsAllDay={ignoreIsAllDay}
          ,
          attrs: this.v3 ? undefined : {
            format: this.$props.format,
            dataItem: ri,
            viewItem: this.$props.viewItem,
            item: this.$props.item,
            vertical: vertical
          },
          dataItem: ri,
          viewItem: this.$props.viewItem,
          item: this.$props.item,
          vertical: vertical
        });
      }, this) : h(SchedulerResize, {
        format: this.$props.format
        //   ignoreIsAllDay={ignoreIsAllDay}
        ,
        attrs: this.v3 ? undefined : {
          format: this.$props.format,
          dataItem: this.compResizeItem,
          viewItem: this.$props.viewItem,
          item: this.$props.item,
          vertical: vertical
        },
        dataItem: this.compResizeItem,
        viewItem: this.$props.viewItem,
        item: this.$props.item,
        vertical: vertical
      }));
    };
    return (
      // @ts-ignore  function children
      h(BaseView, {
        id: this.$props.id,
        attrs: this.v3 ? undefined : {
          id: this.$props.id,
          viewProps: __assign({}, this.$props),
          ranges: __spreadArray(__spreadArray([], this.dayRanges, true), this.timeRanges, true),
          baseSlots: __spreadArray(__spreadArray([], daySlots, true), timeSlots, true)
        },
        viewProps: __assign({}, this.$props),
        "class": 'k-scheduler-day-view',
        ranges: __spreadArray(__spreadArray([], this.dayRanges, true), this.timeRanges, true),
        baseSlots: __spreadArray(__spreadArray([], daySlots, true), timeSlots, true)
      }, this.v3 ? function () {
        return [h("div", {
          "class": "k-scheduler-head"
        }, [_this2.ks.orientation === 'horizontal' ? [
        // @ts-ignore  function children
        h(HorizontalResourceIterator, {
          nested: true,
          attrs: _this2.v3 ? undefined : {
            nested: true,
            group: _this2.ks.props.group,
            resources: _this2.ks.props.resources,
            rowContent: DayViewGroupRowContent,
            childRowContent: DayViewGroupRowContent
          },
          group: _this2.ks.props.group,
          resources: _this2.ks.props.resources,
          rowContent: DayViewGroupRowContent,
          childRowContent: DayViewGroupRowContent
        }, _this2.v3 ? function () {
          return [h(DayViewHead, {
            timeRanges: _this2.timeRanges,
            attrs: _this2.v3 ? undefined : {
              timeRanges: _this2.timeRanges,
              dateHeaderCell: _this2.$props.dateHeaderCell
            },
            dateHeaderCell: _this2.$props.dateHeaderCell
          })];
        } : [h(DayViewHead, {
          timeRanges: _this2.timeRanges,
          attrs: _this2.v3 ? undefined : {
            timeRanges: _this2.timeRanges,
            dateHeaderCell: _this2.$props.dateHeaderCell
          },
          dateHeaderCell: _this2.$props.dateHeaderCell
        })]),
        // @ts-ignore  function children
        h(HorizontalResourceIterator, {
          group: _this2.ks.props.group,
          attrs: _this2.v3 ? undefined : {
            group: _this2.ks.props.group,
            resources: _this2.ks.props.resources,
            rowContent: DayViewAllDayRowContent,
            childRowContent: DayViewAllDayRowContent
          },
          resources: _this2.ks.props.resources,
          rowContent: DayViewAllDayRowContent,
          childRowContent: DayViewAllDayRowContent
        }, _this2.v3 ? function () {
          return [h(DayViewAllDaySlots, {
            editable: _this2.$props.editable,
            attrs: _this2.v3 ? undefined : {
              editable: _this2.$props.editable,
              dayRanges: _this2.dayRanges,
              daySlots: daySlots,
              slotRender: _this2.$props.slotRender,
              viewSlot: _this2.$props.viewSlot,
              numberOfDays: numberOfDays,
              workWeekStart: workWeekStart,
              workWeekEnd: workWeekEnd
            },
            dayRanges: _this2.dayRanges,
            daySlots: daySlots,
            slotRender: _this2.$props.slotRender,
            viewSlot: _this2.$props.viewSlot,
            numberOfDays: numberOfDays,
            workWeekStart: workWeekStart,
            workWeekEnd: workWeekEnd,
            onDataaction: _this2.handleDataAction,
            on: _this2.v3 ? undefined : {
              "dataaction": _this2.handleDataAction
            }
          })];
        } : [h(DayViewAllDaySlots, {
          editable: _this2.$props.editable,
          attrs: _this2.v3 ? undefined : {
            editable: _this2.$props.editable,
            dayRanges: _this2.dayRanges,
            daySlots: daySlots,
            slotRender: _this2.$props.slotRender,
            viewSlot: _this2.$props.viewSlot,
            numberOfDays: numberOfDays,
            workWeekStart: workWeekStart,
            workWeekEnd: workWeekEnd
          },
          dayRanges: _this2.dayRanges,
          daySlots: daySlots,
          slotRender: _this2.$props.slotRender,
          viewSlot: _this2.$props.viewSlot,
          numberOfDays: numberOfDays,
          workWeekStart: workWeekStart,
          workWeekEnd: workWeekEnd,
          onDataaction: _this2.handleDataAction,
          on: _this2.v3 ? undefined : {
            "dataaction": _this2.handleDataAction
          }
        })]), _this2.hasMounted && dayItems.map(function (item) {
          return h(EditItem, {
            key: item.isRecurring ? "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index, ":").concat(item.originalStart) : "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index),
            uid: item.uid,
            attrs: this.v3 ? undefined : {
              uid: item.uid,
              start: item.start,
              end: item.end,
              originalStart: item.originalStart,
              startTimezone: item.startTimezone,
              endTimezone: item.endTimezone,
              isAllDay: item.isAllDay,
              title: item.title,
              description: item.description,
              occurrenceId: item.occurrenceId,
              recurrenceExceptions: item.recurrenceExceptions,
              recurrenceRule: item.recurrenceRule,
              recurrenceId: item.recurrenceId,
              dataItem: item.dataItem,
              itemRef: item.itemRef,
              head: item.head,
              tail: item.tail,
              order: item.order,
              zonedStart: item.zonedStart,
              zonedEnd: item.zonedEnd,
              slots: item.slots,
              group: item.group,
              range: item.range,
              isException: item.isException,
              isRecurring: item.isRecurring,
              form: this.$props.form,
              item: this.$props.item,
              viewItem: this.$props.viewItem,
              editable: this.$props.editable,
              vertical: false
            },
            start: item.start,
            end: item.end,
            originalStart: item.originalStart,
            startTimezone: item.startTimezone,
            endTimezone: item.endTimezone,
            isAllDay: item.isAllDay,
            title: item.title,
            description: item.description,
            occurrenceId: item.occurrenceId,
            recurrenceExceptions: item.recurrenceExceptions,
            recurrenceRule: item.recurrenceRule,
            recurrenceId: item.recurrenceId,
            dataItem: item.dataItem,
            itemRef: item.itemRef,
            head: item.head,
            tail: item.tail,
            order: item.order,
            zonedStart: item.zonedStart,
            zonedEnd: item.zonedEnd,
            slots: item.slots,
            group: item.group,
            range: item.range,
            isException: item.isException,
            isRecurring: item.isRecurring,
            form: this.$props.form,
            onDataaction: this.handleDataAction,
            on: this.v3 ? undefined : {
              "dataaction": this.handleDataAction,
              "dragitemchange": this.handleDragItemChange,
              "resizeitemchange": this.handleResizeItemChange
            },
            onDragitemchange: this.handleDragItemChange,
            onResizeitemchange: this.handleResizeItemChange,
            item: this.$props.item,
            viewItem: this.$props.viewItem,
            editable: this.$props.editable,
            vertical: false
          });
        }, _this2), _this2.compDragItem && _this2.compDragItem.isAllDay && dragItemClue.call(_this2, false), _this2.compResizeItem && _this2.compResizeItem.isAllDay && resizeItemClue.call(_this2, false)] :
        // @ts-ignore  function children
        h(VerticalResourceIterator, {
          group: _this2.ks.props.group,
          attrs: _this2.v3 ? undefined : {
            group: _this2.ks.props.group,
            resources: _this2.ks.props.resources,
            emptyCell: true,
            editable: _this2.$props.editable
          },
          resources: _this2.ks.props.resources,
          emptyCell: true,
          editable: _this2.$props.editable
        }, _this2.v3 ? function () {
          return [h(DayViewHead, {
            timeRanges: _this2.timeRanges,
            attrs: _this2.v3 ? undefined : {
              timeRanges: _this2.timeRanges,
              dateHeaderCell: _this2.$props.dateHeaderCell
            },
            dateHeaderCell: _this2.$props.dateHeaderCell
          })];
        } : [h(DayViewHead, {
          timeRanges: _this2.timeRanges,
          attrs: _this2.v3 ? undefined : {
            timeRanges: _this2.timeRanges,
            dateHeaderCell: _this2.$props.dateHeaderCell
          },
          dateHeaderCell: _this2.$props.dateHeaderCell
        })])]), h("div", {
          "class": "k-scheduler-body"
        }, [_this2.ks.orientation === 'horizontal' ? [timeSlots.filter(function (slot) {
          return slot.group.index === FIRST_INDEX && slot.range.index === FIRST_INDEX;
        }).map(function (root, rootIndex) {
          var _this3 = this;
          return (
            // @ts-ignore  function children
            h(HorizontalResourceIterator, {
              key: root.index,
              nested: false,
              attrs: this.v3 ? undefined : {
                nested: false,
                group: this.ks.props.group,
                resources: this.ks.props.resources,
                rowContent: DayViewRowContent,
                rowContentProps: {
                  timeHeaderCell: this.$props.timeHeaderCell,
                  isMaster: rootIndex % slotDivisions === 0,
                  isLast: (rootIndex + 1) % slotDivisions === 0,
                  contentSlot: root
                }
              },
              group: this.ks.props.group,
              resources: this.ks.props.resources,
              rowContent: DayViewRowContent,
              rowContentProps: {
                timeHeaderCell: this.$props.timeHeaderCell,
                isMaster: rootIndex % slotDivisions === 0,
                isLast: (rootIndex + 1) % slotDivisions === 0,
                contentSlot: root
              }
            }, this.v3 ? function () {
              return [h(DayViewMiddleRow, {
                slotRender: _this3.$props.slotRender,
                attrs: _this3.v3 ? undefined : {
                  slotRender: _this3.$props.slotRender,
                  viewSlot: _this3.$props.viewSlot,
                  timeRanges: _this3.timeRanges,
                  timeSlots: timeSlots,
                  slotDivisions: slotDivisions,
                  rootIndex: rootIndex,
                  root: root,
                  numberOfDays: numberOfDays,
                  workDayStart: workDayStart,
                  workDayEnd: workDayEnd,
                  workWeekStart: workWeekStart,
                  workWeekEnd: workWeekEnd,
                  editable: _this3.$props.editable
                },
                viewSlot: _this3.$props.viewSlot,
                timeRanges: _this3.timeRanges,
                timeSlots: timeSlots,
                slotDivisions: slotDivisions,
                rootIndex: rootIndex,
                root: root,
                numberOfDays: numberOfDays,
                workDayStart: workDayStart,
                workDayEnd: workDayEnd,
                workWeekStart: workWeekStart,
                workWeekEnd: workWeekEnd,
                onDataaction: _this3.handleDataAction,
                on: _this3.v3 ? undefined : {
                  "dataaction": _this3.handleDataAction
                },
                editable: _this3.$props.editable
              })];
            } : [h(DayViewMiddleRow, {
              slotRender: _this3.$props.slotRender,
              attrs: _this3.v3 ? undefined : {
                slotRender: _this3.$props.slotRender,
                viewSlot: _this3.$props.viewSlot,
                timeRanges: _this3.timeRanges,
                timeSlots: timeSlots,
                slotDivisions: slotDivisions,
                rootIndex: rootIndex,
                root: root,
                numberOfDays: numberOfDays,
                workDayStart: workDayStart,
                workDayEnd: workDayEnd,
                workWeekStart: workWeekStart,
                workWeekEnd: workWeekEnd,
                editable: _this3.$props.editable
              },
              viewSlot: _this3.$props.viewSlot,
              timeRanges: _this3.timeRanges,
              timeSlots: timeSlots,
              slotDivisions: slotDivisions,
              rootIndex: rootIndex,
              root: root,
              numberOfDays: numberOfDays,
              workDayStart: workDayStart,
              workDayEnd: workDayEnd,
              workWeekStart: workWeekStart,
              workWeekEnd: workWeekEnd,
              onDataaction: _this3.handleDataAction,
              on: _this3.v3 ? undefined : {
                "dataaction": _this3.handleDataAction
              },
              editable: _this3.$props.editable
            })])
          );
        }, _this2), _this2.$props.currentTimeMarker && intersects(first(_this2.timeRanges).start, last(_this2.timeRanges).end, new Date(), new Date(), true) && [h(CurrentTimeMarkerArrow), h(CurrentTimeMarker)]] : [
        // @ts-ignore  function children
        h(VerticalResourceIterator, {
          nested: true,
          attrs: _this2.v3 ? undefined : {
            nested: true,
            group: _this2.ks.props.group,
            resources: _this2.ks.props.resources,
            more: {
              timeRanges: _this2.timeRanges,
              timeSlots: timeSlots,
              workDayStart: workDayStart,
              workDayEnd: workDayEnd,
              numberOfDays: numberOfDays,
              workWeekStart: workWeekStart,
              workWeekEnd: workWeekEnd,
              slotRender: _this2.$props.slotRender,
              viewSlot: _this2.$props.viewSlot,
              editable: _this2.$props.editable,
              currentTimeMarker: _this2.$props.currentTimeMarker
            }
          },
          group: _this2.ks.props.group,
          resources: _this2.ks.props.resources,
          onDataaction: _this2.handleDataAction,
          on: _this2.v3 ? undefined : {
            "dataaction": _this2.handleDataAction
          },
          more: {
            timeRanges: _this2.timeRanges,
            timeSlots: timeSlots,
            workDayStart: workDayStart,
            workDayEnd: workDayEnd,
            numberOfDays: numberOfDays,
            workWeekStart: workWeekStart,
            workWeekEnd: workWeekEnd,
            slotRender: _this2.$props.slotRender,
            viewSlot: _this2.$props.viewSlot,
            editable: _this2.$props.editable,
            currentTimeMarker: _this2.$props.currentTimeMarker
          }
        }, _this2.v3 ? function () {
          return [h(DayViewVerticalRow, {
            onDataaction: _this2.handleDataAction,
            on: _this2.v3 ? undefined : {
              "dataaction": _this2.handleDataAction
            },
            daySlots: daySlots,
            attrs: _this2.v3 ? undefined : {
              daySlots: daySlots,
              timeSlots: timeSlots,
              dayRanges: _this2.dayRanges,
              editable: _this2.$props.editable
            },
            timeSlots: timeSlots,
            dayRanges: _this2.dayRanges,
            editable: _this2.$props.editable
          })];
        } : [h(DayViewVerticalRow, {
          onDataaction: _this2.handleDataAction,
          on: _this2.v3 ? undefined : {
            "dataaction": _this2.handleDataAction
          },
          daySlots: daySlots,
          attrs: _this2.v3 ? undefined : {
            daySlots: daySlots,
            timeSlots: timeSlots,
            dayRanges: _this2.dayRanges,
            editable: _this2.$props.editable
          },
          timeSlots: timeSlots,
          dayRanges: _this2.dayRanges,
          editable: _this2.$props.editable
        })]), _this2.hasMounted && dayItems.map(function (item) {
          return h(EditItem, {
            key: item.isRecurring ? "".concat(item.uid, ":").concat(item.group.index, " : ").concat(item.range.index, " : ").concat(item.originalStart) : "".concat(item.uid, ":").concat(item.group.index, " : ").concat(item.range.index),
            uid: item.uid,
            attrs: this.v3 ? undefined : {
              uid: item.uid,
              start: item.start,
              end: item.end,
              originalStart: item.originalStart,
              startTimezone: item.startTimezone,
              endTimezone: item.endTimezone,
              isAllDay: item.isAllDay,
              title: item.title,
              description: item.description,
              occurrenceId: item.occurrenceId,
              recurrenceExceptions: item.recurrenceExceptions,
              recurrenceRule: item.recurrenceRule,
              recurrenceId: item.recurrenceId,
              dataItem: item.dataItem,
              itemRef: item.itemRef,
              head: item.head,
              tail: item.tail,
              order: item.order,
              zonedStart: item.zonedStart,
              zonedEnd: item.zonedEnd,
              slots: item.slots,
              group: item.group,
              range: item.range,
              isException: item.isException,
              isRecurring: item.isRecurring,
              viewItem: this.$props.viewItem,
              item: this.$props.item,
              form: this.$props.form,
              editable: this.$props.editable,
              vertical: false
            },
            start: item.start,
            end: item.end,
            originalStart: item.originalStart,
            startTimezone: item.startTimezone,
            endTimezone: item.endTimezone,
            isAllDay: item.isAllDay,
            title: item.title,
            description: item.description,
            occurrenceId: item.occurrenceId,
            recurrenceExceptions: item.recurrenceExceptions,
            recurrenceRule: item.recurrenceRule,
            recurrenceId: item.recurrenceId,
            dataItem: item.dataItem,
            itemRef: item.itemRef,
            head: item.head,
            tail: item.tail,
            order: item.order,
            zonedStart: item.zonedStart,
            zonedEnd: item.zonedEnd,
            slots: item.slots,
            group: item.group,
            range: item.range,
            isException: item.isException,
            isRecurring: item.isRecurring,
            onDataaction: this.handleDataAction,
            on: this.v3 ? undefined : {
              "dataaction": this.handleDataAction,
              "dragitemchange": this.handleDragItemChange,
              "resizeitemchange": this.handleResizeItemChange
            },
            onDragitemchange: this.handleDragItemChange,
            onResizeitemchange: this.handleResizeItemChange,
            viewItem: this.$props.viewItem,
            item: this.$props.item,
            form: this.$props.form,
            editable: this.$props.editable,
            vertical: false
          });
        }, _this2), _this2.compDragItem && _this2.compDragItem.isAllDay && dragItemClue.call(_this2, true), _this2.compResizeItem && _this2.compResizeItem.isAllDay && resizeItemClue.call(_this2, true)], _this2.hasMounted && timeItems.map(function (item) {
          return h(EditItem, {
            key: item.isRecurring ? "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index, ":").concat(item.originalStart) : "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index),
            uid: item.uid,
            attrs: this.v3 ? undefined : {
              uid: item.uid,
              start: item.start,
              end: item.end,
              originalStart: item.originalStart,
              startTimezone: item.startTimezone,
              endTimezone: item.endTimezone,
              isAllDay: item.isAllDay,
              title: item.title,
              description: item.description,
              occurrenceId: item.occurrenceId,
              recurrenceExceptions: item.recurrenceExceptions,
              recurrenceRule: item.recurrenceRule,
              recurrenceId: item.recurrenceId,
              dataItem: item.dataItem,
              itemRef: item.itemRef,
              head: item.head,
              tail: item.tail,
              order: item.order,
              zonedStart: item.zonedStart,
              zonedEnd: item.zonedEnd,
              slots: item.slots,
              group: item.group,
              range: item.range,
              isException: item.isException,
              isRecurring: item.isRecurring,
              format: 't',
              viewItem: this.$props.viewItem,
              item: this.$props.item,
              form: this.$props.form,
              editable: this.$props.editable,
              vertical: true
            },
            start: item.start,
            end: item.end,
            originalStart: item.originalStart,
            startTimezone: item.startTimezone,
            endTimezone: item.endTimezone,
            isAllDay: item.isAllDay,
            title: item.title,
            description: item.description,
            occurrenceId: item.occurrenceId,
            recurrenceExceptions: item.recurrenceExceptions,
            recurrenceRule: item.recurrenceRule,
            recurrenceId: item.recurrenceId,
            dataItem: item.dataItem,
            itemRef: item.itemRef,
            head: item.head,
            tail: item.tail,
            order: item.order,
            zonedStart: item.zonedStart,
            zonedEnd: item.zonedEnd,
            slots: item.slots,
            group: item.group,
            range: item.range,
            isException: item.isException,
            isRecurring: item.isRecurring,
            format: 't',
            onDataaction: this.handleDataAction,
            on: this.v3 ? undefined : {
              "dataaction": this.handleDataAction,
              "dragitemchange": this.handleDragItemChange,
              "resizeitemchange": this.handleResizeItemChange
            },
            onDragitemchange: this.handleDragItemChange,
            onResizeitemchange: this.handleResizeItemChange,
            viewItem: this.$props.viewItem,
            item: this.$props.item,
            form: this.$props.form,
            editable: this.$props.editable,
            vertical: true
          });
        }, _this2), _this2.compDragItem && !_this2.compDragItem.isAllDay && dragItemClue.call(_this2, true), _this2.compResizeItem && !_this2.compResizeItem.isAllDay && resizeItemClue.call(_this2, true)])];
      } : [h("div", {
        "class": "k-scheduler-head"
      }, [_this2.ks.orientation === 'horizontal' ? [h(HorizontalResourceIterator, {
        nested: true,
        attrs: _this2.v3 ? undefined : {
          nested: true,
          group: _this2.ks.props.group,
          resources: _this2.ks.props.resources,
          rowContent: DayViewGroupRowContent,
          childRowContent: DayViewGroupRowContent
        },
        group: _this2.ks.props.group,
        resources: _this2.ks.props.resources,
        rowContent: DayViewGroupRowContent,
        childRowContent: DayViewGroupRowContent
      }, _this2.v3 ? function () {
        return [h(DayViewHead, {
          timeRanges: _this2.timeRanges,
          attrs: _this2.v3 ? undefined : {
            timeRanges: _this2.timeRanges,
            dateHeaderCell: _this2.$props.dateHeaderCell
          },
          dateHeaderCell: _this2.$props.dateHeaderCell
        })];
      } : [h(DayViewHead, {
        timeRanges: _this2.timeRanges,
        attrs: _this2.v3 ? undefined : {
          timeRanges: _this2.timeRanges,
          dateHeaderCell: _this2.$props.dateHeaderCell
        },
        dateHeaderCell: _this2.$props.dateHeaderCell
      })]), h(HorizontalResourceIterator, {
        group: _this2.ks.props.group,
        attrs: _this2.v3 ? undefined : {
          group: _this2.ks.props.group,
          resources: _this2.ks.props.resources,
          rowContent: DayViewAllDayRowContent,
          childRowContent: DayViewAllDayRowContent
        },
        resources: _this2.ks.props.resources,
        rowContent: DayViewAllDayRowContent,
        childRowContent: DayViewAllDayRowContent
      }, _this2.v3 ? function () {
        return [h(DayViewAllDaySlots, {
          editable: _this2.$props.editable,
          attrs: _this2.v3 ? undefined : {
            editable: _this2.$props.editable,
            dayRanges: _this2.dayRanges,
            daySlots: daySlots,
            slotRender: _this2.$props.slotRender,
            viewSlot: _this2.$props.viewSlot,
            numberOfDays: numberOfDays,
            workWeekStart: workWeekStart,
            workWeekEnd: workWeekEnd
          },
          dayRanges: _this2.dayRanges,
          daySlots: daySlots,
          slotRender: _this2.$props.slotRender,
          viewSlot: _this2.$props.viewSlot,
          numberOfDays: numberOfDays,
          workWeekStart: workWeekStart,
          workWeekEnd: workWeekEnd,
          onDataaction: _this2.handleDataAction,
          on: _this2.v3 ? undefined : {
            "dataaction": _this2.handleDataAction
          }
        })];
      } : [h(DayViewAllDaySlots, {
        editable: _this2.$props.editable,
        attrs: _this2.v3 ? undefined : {
          editable: _this2.$props.editable,
          dayRanges: _this2.dayRanges,
          daySlots: daySlots,
          slotRender: _this2.$props.slotRender,
          viewSlot: _this2.$props.viewSlot,
          numberOfDays: numberOfDays,
          workWeekStart: workWeekStart,
          workWeekEnd: workWeekEnd
        },
        dayRanges: _this2.dayRanges,
        daySlots: daySlots,
        slotRender: _this2.$props.slotRender,
        viewSlot: _this2.$props.viewSlot,
        numberOfDays: numberOfDays,
        workWeekStart: workWeekStart,
        workWeekEnd: workWeekEnd,
        onDataaction: _this2.handleDataAction,
        on: _this2.v3 ? undefined : {
          "dataaction": _this2.handleDataAction
        }
      })]), _this2.hasMounted && dayItems.map(function (item) {
        return h(EditItem, {
          key: item.isRecurring ? "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index, ":").concat(item.originalStart) : "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index),
          uid: item.uid,
          attrs: this.v3 ? undefined : {
            uid: item.uid,
            start: item.start,
            end: item.end,
            originalStart: item.originalStart,
            startTimezone: item.startTimezone,
            endTimezone: item.endTimezone,
            isAllDay: item.isAllDay,
            title: item.title,
            description: item.description,
            occurrenceId: item.occurrenceId,
            recurrenceExceptions: item.recurrenceExceptions,
            recurrenceRule: item.recurrenceRule,
            recurrenceId: item.recurrenceId,
            dataItem: item.dataItem,
            itemRef: item.itemRef,
            head: item.head,
            tail: item.tail,
            order: item.order,
            zonedStart: item.zonedStart,
            zonedEnd: item.zonedEnd,
            slots: item.slots,
            group: item.group,
            range: item.range,
            isException: item.isException,
            isRecurring: item.isRecurring,
            form: this.$props.form,
            item: this.$props.item,
            viewItem: this.$props.viewItem,
            editable: this.$props.editable,
            vertical: false
          },
          start: item.start,
          end: item.end,
          originalStart: item.originalStart,
          startTimezone: item.startTimezone,
          endTimezone: item.endTimezone,
          isAllDay: item.isAllDay,
          title: item.title,
          description: item.description,
          occurrenceId: item.occurrenceId,
          recurrenceExceptions: item.recurrenceExceptions,
          recurrenceRule: item.recurrenceRule,
          recurrenceId: item.recurrenceId,
          dataItem: item.dataItem,
          itemRef: item.itemRef,
          head: item.head,
          tail: item.tail,
          order: item.order,
          zonedStart: item.zonedStart,
          zonedEnd: item.zonedEnd,
          slots: item.slots,
          group: item.group,
          range: item.range,
          isException: item.isException,
          isRecurring: item.isRecurring,
          form: this.$props.form,
          onDataaction: this.handleDataAction,
          on: this.v3 ? undefined : {
            "dataaction": this.handleDataAction,
            "dragitemchange": this.handleDragItemChange,
            "resizeitemchange": this.handleResizeItemChange
          },
          onDragitemchange: this.handleDragItemChange,
          onResizeitemchange: this.handleResizeItemChange,
          item: this.$props.item,
          viewItem: this.$props.viewItem,
          editable: this.$props.editable,
          vertical: false
        });
      }, _this2), _this2.compDragItem && _this2.compDragItem.isAllDay && dragItemClue.call(_this2, false), _this2.compResizeItem && _this2.compResizeItem.isAllDay && resizeItemClue.call(_this2, false)] : h(VerticalResourceIterator, {
        group: _this2.ks.props.group,
        attrs: _this2.v3 ? undefined : {
          group: _this2.ks.props.group,
          resources: _this2.ks.props.resources,
          emptyCell: true,
          editable: _this2.$props.editable
        },
        resources: _this2.ks.props.resources,
        emptyCell: true,
        editable: _this2.$props.editable
      }, _this2.v3 ? function () {
        return [h(DayViewHead, {
          timeRanges: _this2.timeRanges,
          attrs: _this2.v3 ? undefined : {
            timeRanges: _this2.timeRanges,
            dateHeaderCell: _this2.$props.dateHeaderCell
          },
          dateHeaderCell: _this2.$props.dateHeaderCell
        })];
      } : [h(DayViewHead, {
        timeRanges: _this2.timeRanges,
        attrs: _this2.v3 ? undefined : {
          timeRanges: _this2.timeRanges,
          dateHeaderCell: _this2.$props.dateHeaderCell
        },
        dateHeaderCell: _this2.$props.dateHeaderCell
      })])]), h("div", {
        "class": "k-scheduler-body"
      }, [_this2.ks.orientation === 'horizontal' ? [timeSlots.filter(function (slot) {
        return slot.group.index === FIRST_INDEX && slot.range.index === FIRST_INDEX;
      }).map(function (root, rootIndex) {
        var _this3 = this;
        return h(HorizontalResourceIterator, {
          key: root.index,
          nested: false,
          attrs: this.v3 ? undefined : {
            nested: false,
            group: this.ks.props.group,
            resources: this.ks.props.resources,
            rowContent: DayViewRowContent,
            rowContentProps: {
              timeHeaderCell: this.$props.timeHeaderCell,
              isMaster: rootIndex % slotDivisions === 0,
              isLast: (rootIndex + 1) % slotDivisions === 0,
              contentSlot: root
            }
          },
          group: this.ks.props.group,
          resources: this.ks.props.resources,
          rowContent: DayViewRowContent,
          rowContentProps: {
            timeHeaderCell: this.$props.timeHeaderCell,
            isMaster: rootIndex % slotDivisions === 0,
            isLast: (rootIndex + 1) % slotDivisions === 0,
            contentSlot: root
          }
        }, this.v3 ? function () {
          return [h(DayViewMiddleRow, {
            slotRender: _this3.$props.slotRender,
            attrs: _this3.v3 ? undefined : {
              slotRender: _this3.$props.slotRender,
              viewSlot: _this3.$props.viewSlot,
              timeRanges: _this3.timeRanges,
              timeSlots: timeSlots,
              slotDivisions: slotDivisions,
              rootIndex: rootIndex,
              root: root,
              numberOfDays: numberOfDays,
              workDayStart: workDayStart,
              workDayEnd: workDayEnd,
              workWeekStart: workWeekStart,
              workWeekEnd: workWeekEnd,
              editable: _this3.$props.editable
            },
            viewSlot: _this3.$props.viewSlot,
            timeRanges: _this3.timeRanges,
            timeSlots: timeSlots,
            slotDivisions: slotDivisions,
            rootIndex: rootIndex,
            root: root,
            numberOfDays: numberOfDays,
            workDayStart: workDayStart,
            workDayEnd: workDayEnd,
            workWeekStart: workWeekStart,
            workWeekEnd: workWeekEnd,
            onDataaction: _this3.handleDataAction,
            on: _this3.v3 ? undefined : {
              "dataaction": _this3.handleDataAction
            },
            editable: _this3.$props.editable
          })];
        } : [h(DayViewMiddleRow, {
          slotRender: _this3.$props.slotRender,
          attrs: _this3.v3 ? undefined : {
            slotRender: _this3.$props.slotRender,
            viewSlot: _this3.$props.viewSlot,
            timeRanges: _this3.timeRanges,
            timeSlots: timeSlots,
            slotDivisions: slotDivisions,
            rootIndex: rootIndex,
            root: root,
            numberOfDays: numberOfDays,
            workDayStart: workDayStart,
            workDayEnd: workDayEnd,
            workWeekStart: workWeekStart,
            workWeekEnd: workWeekEnd,
            editable: _this3.$props.editable
          },
          viewSlot: _this3.$props.viewSlot,
          timeRanges: _this3.timeRanges,
          timeSlots: timeSlots,
          slotDivisions: slotDivisions,
          rootIndex: rootIndex,
          root: root,
          numberOfDays: numberOfDays,
          workDayStart: workDayStart,
          workDayEnd: workDayEnd,
          workWeekStart: workWeekStart,
          workWeekEnd: workWeekEnd,
          onDataaction: _this3.handleDataAction,
          on: _this3.v3 ? undefined : {
            "dataaction": _this3.handleDataAction
          },
          editable: _this3.$props.editable
        })]);
      }, _this2), _this2.$props.currentTimeMarker && intersects(first(_this2.timeRanges).start, last(_this2.timeRanges).end, new Date(), new Date(), true) && [h(CurrentTimeMarkerArrow), h(CurrentTimeMarker)]] : [h(VerticalResourceIterator, {
        nested: true,
        attrs: _this2.v3 ? undefined : {
          nested: true,
          group: _this2.ks.props.group,
          resources: _this2.ks.props.resources,
          more: {
            timeRanges: _this2.timeRanges,
            timeSlots: timeSlots,
            workDayStart: workDayStart,
            workDayEnd: workDayEnd,
            numberOfDays: numberOfDays,
            workWeekStart: workWeekStart,
            workWeekEnd: workWeekEnd,
            slotRender: _this2.$props.slotRender,
            viewSlot: _this2.$props.viewSlot,
            editable: _this2.$props.editable,
            currentTimeMarker: _this2.$props.currentTimeMarker
          }
        },
        group: _this2.ks.props.group,
        resources: _this2.ks.props.resources,
        onDataaction: _this2.handleDataAction,
        on: _this2.v3 ? undefined : {
          "dataaction": _this2.handleDataAction
        },
        more: {
          timeRanges: _this2.timeRanges,
          timeSlots: timeSlots,
          workDayStart: workDayStart,
          workDayEnd: workDayEnd,
          numberOfDays: numberOfDays,
          workWeekStart: workWeekStart,
          workWeekEnd: workWeekEnd,
          slotRender: _this2.$props.slotRender,
          viewSlot: _this2.$props.viewSlot,
          editable: _this2.$props.editable,
          currentTimeMarker: _this2.$props.currentTimeMarker
        }
      }, _this2.v3 ? function () {
        return [h(DayViewVerticalRow, {
          onDataaction: _this2.handleDataAction,
          on: _this2.v3 ? undefined : {
            "dataaction": _this2.handleDataAction
          },
          daySlots: daySlots,
          attrs: _this2.v3 ? undefined : {
            daySlots: daySlots,
            timeSlots: timeSlots,
            dayRanges: _this2.dayRanges,
            editable: _this2.$props.editable
          },
          timeSlots: timeSlots,
          dayRanges: _this2.dayRanges,
          editable: _this2.$props.editable
        })];
      } : [h(DayViewVerticalRow, {
        onDataaction: _this2.handleDataAction,
        on: _this2.v3 ? undefined : {
          "dataaction": _this2.handleDataAction
        },
        daySlots: daySlots,
        attrs: _this2.v3 ? undefined : {
          daySlots: daySlots,
          timeSlots: timeSlots,
          dayRanges: _this2.dayRanges,
          editable: _this2.$props.editable
        },
        timeSlots: timeSlots,
        dayRanges: _this2.dayRanges,
        editable: _this2.$props.editable
      })]), _this2.hasMounted && dayItems.map(function (item) {
        return h(EditItem, {
          key: item.isRecurring ? "".concat(item.uid, ":").concat(item.group.index, " : ").concat(item.range.index, " : ").concat(item.originalStart) : "".concat(item.uid, ":").concat(item.group.index, " : ").concat(item.range.index),
          uid: item.uid,
          attrs: this.v3 ? undefined : {
            uid: item.uid,
            start: item.start,
            end: item.end,
            originalStart: item.originalStart,
            startTimezone: item.startTimezone,
            endTimezone: item.endTimezone,
            isAllDay: item.isAllDay,
            title: item.title,
            description: item.description,
            occurrenceId: item.occurrenceId,
            recurrenceExceptions: item.recurrenceExceptions,
            recurrenceRule: item.recurrenceRule,
            recurrenceId: item.recurrenceId,
            dataItem: item.dataItem,
            itemRef: item.itemRef,
            head: item.head,
            tail: item.tail,
            order: item.order,
            zonedStart: item.zonedStart,
            zonedEnd: item.zonedEnd,
            slots: item.slots,
            group: item.group,
            range: item.range,
            isException: item.isException,
            isRecurring: item.isRecurring,
            viewItem: this.$props.viewItem,
            item: this.$props.item,
            form: this.$props.form,
            editable: this.$props.editable,
            vertical: false
          },
          start: item.start,
          end: item.end,
          originalStart: item.originalStart,
          startTimezone: item.startTimezone,
          endTimezone: item.endTimezone,
          isAllDay: item.isAllDay,
          title: item.title,
          description: item.description,
          occurrenceId: item.occurrenceId,
          recurrenceExceptions: item.recurrenceExceptions,
          recurrenceRule: item.recurrenceRule,
          recurrenceId: item.recurrenceId,
          dataItem: item.dataItem,
          itemRef: item.itemRef,
          head: item.head,
          tail: item.tail,
          order: item.order,
          zonedStart: item.zonedStart,
          zonedEnd: item.zonedEnd,
          slots: item.slots,
          group: item.group,
          range: item.range,
          isException: item.isException,
          isRecurring: item.isRecurring,
          onDataaction: this.handleDataAction,
          on: this.v3 ? undefined : {
            "dataaction": this.handleDataAction,
            "dragitemchange": this.handleDragItemChange,
            "resizeitemchange": this.handleResizeItemChange
          },
          onDragitemchange: this.handleDragItemChange,
          onResizeitemchange: this.handleResizeItemChange,
          viewItem: this.$props.viewItem,
          item: this.$props.item,
          form: this.$props.form,
          editable: this.$props.editable,
          vertical: false
        });
      }, _this2), _this2.compDragItem && _this2.compDragItem.isAllDay && dragItemClue.call(_this2, true), _this2.compResizeItem && _this2.compResizeItem.isAllDay && resizeItemClue.call(_this2, true)], _this2.hasMounted && timeItems.map(function (item) {
        return h(EditItem, {
          key: item.isRecurring ? "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index, ":").concat(item.originalStart) : "".concat(item.uid, ":").concat(item.group.index, ":").concat(item.range.index),
          uid: item.uid,
          attrs: this.v3 ? undefined : {
            uid: item.uid,
            start: item.start,
            end: item.end,
            originalStart: item.originalStart,
            startTimezone: item.startTimezone,
            endTimezone: item.endTimezone,
            isAllDay: item.isAllDay,
            title: item.title,
            description: item.description,
            occurrenceId: item.occurrenceId,
            recurrenceExceptions: item.recurrenceExceptions,
            recurrenceRule: item.recurrenceRule,
            recurrenceId: item.recurrenceId,
            dataItem: item.dataItem,
            itemRef: item.itemRef,
            head: item.head,
            tail: item.tail,
            order: item.order,
            zonedStart: item.zonedStart,
            zonedEnd: item.zonedEnd,
            slots: item.slots,
            group: item.group,
            range: item.range,
            isException: item.isException,
            isRecurring: item.isRecurring,
            format: 't',
            viewItem: this.$props.viewItem,
            item: this.$props.item,
            form: this.$props.form,
            editable: this.$props.editable,
            vertical: true
          },
          start: item.start,
          end: item.end,
          originalStart: item.originalStart,
          startTimezone: item.startTimezone,
          endTimezone: item.endTimezone,
          isAllDay: item.isAllDay,
          title: item.title,
          description: item.description,
          occurrenceId: item.occurrenceId,
          recurrenceExceptions: item.recurrenceExceptions,
          recurrenceRule: item.recurrenceRule,
          recurrenceId: item.recurrenceId,
          dataItem: item.dataItem,
          itemRef: item.itemRef,
          head: item.head,
          tail: item.tail,
          order: item.order,
          zonedStart: item.zonedStart,
          zonedEnd: item.zonedEnd,
          slots: item.slots,
          group: item.group,
          range: item.range,
          isException: item.isException,
          isRecurring: item.isRecurring,
          format: 't',
          onDataaction: this.handleDataAction,
          on: this.v3 ? undefined : {
            "dataaction": this.handleDataAction,
            "dragitemchange": this.handleDragItemChange,
            "resizeitemchange": this.handleResizeItemChange
          },
          onDragitemchange: this.handleDragItemChange,
          onResizeitemchange: this.handleResizeItemChange,
          viewItem: this.$props.viewItem,
          item: this.$props.item,
          form: this.$props.form,
          editable: this.$props.editable,
          vertical: true
        });
      }, _this2), _this2.compDragItem && !_this2.compDragItem.isAllDay && dragItemClue.call(_this2, true), _this2.compResizeItem && !_this2.compResizeItem.isAllDay && resizeItemClue.call(_this2, true)])])
    );
  },
  methods: {
    handleDataAction: function handleDataAction(action) {
      this.$emit('dataaction', action);
    },
    handleDragItemChange: function handleDragItemChange(item) {
      this.currentDragItem = item;
    },
    handleResizeItemChange: function handleResizeItemChange(item) {
      this.currentResizeItem = item;
    }
  }
};
/** @hidden */
var multiDayViewDateRange = function multiDayViewDateRange(_a) {
  var date = _a.date,
    _b = _a.numberOfDays,
    numberOfDays = _b === void 0 ? 1 : _b,
    timezone = _a.timezone;
  var normalized = ZonedDate.fromLocalDate(date, timezone);
  var firstDay = getDate(normalized);
  var lastDay = addDays(firstDay, numberOfDays);
  var zonedStart = ZonedDate.fromUTCDate(toUTCDateTime(firstDay), timezone);
  var zonedEnd = ZonedDate.fromUTCDate(toUTCDateTime(lastDay), timezone);
  var start = new Date(zonedStart.getTime());
  var end = new Date(zonedEnd.getTime());
  return {
    start: start,
    end: end,
    zonedStart: zonedStart,
    zonedEnd: zonedEnd
  };
};
/** @hidden */
var MultiDayView = MultiDayViewVue2;
export { MultiDayView, MultiDayViewVue2, multiDayViewDateRange };